// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"87":"bbb6342b","324":"bbb6342b","360":"b3aff7ca","385":"ba0a1b4a","629":"bbb6342b","684":"f96feeb7","825":"bfce6ff6","893":"bbb6342b"}[chunkId] + ".css";
};